var BlockCardTemplate = require('./block-card.template');
module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$blocks = _ref.blocks,
    blocks = _ref$blocks === void 0 ? [] : _ref$blocks,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? null : _ref$error,
    _ref$loadingMessage = _ref.loadingMessage,
    loadingMessage = _ref$loadingMessage === void 0 ? 'Fetching block data…' : _ref$loadingMessage;
  var body = '';
  if (loading) {
    body = "\n      <div class=\"explorer-teaser-loading\">\n        <p class=\"explorer-teaser-loading-title\">Fetching block data</p>\n        <p class=\"explorer-teaser-loading-message\">".concat(loadingMessage, "</p>\n      </div>\n    ");
  } else if (error) {
    body = "\n      <div class=\"explorer-teaser-loading explorer-teaser-error\">\n        <p class=\"explorer-teaser-loading-title\">Unable to load blocks</p>\n        <p class=\"explorer-teaser-loading-message\">".concat(error, "</p>\n      </div>\n    ");
  } else if (!blocks.length) {
    body = "\n      <div class=\"explorer-teaser-loading\">\n        <p class=\"explorer-teaser-loading-message\">No blocks available yet.</p>\n      </div>\n    ";
  } else {
    body = blocks.map(function (block) {
      return BlockCardTemplate(block);
    }).join('');
  }
  return "\n    <section class=\"block-teaser explorer-panel\" aria-label=\"Latest blocks\">\n      <div class=\"explorer-panel-header\">\n        <h2 class=\"explorer-heading explorer-m-0\">\n          <a class=\"explorer-link\" href=\"/explorer/blocks\" data-explorer-nav=\"all-blocks\">Latest Blocks</a>\n        </h2>\n      </div>\n      <div class=\"explorer-feed\">\n        ".concat(body, "\n      </div>\n      <div class=\"explorer-panel-footer\">\n        <a class=\"explorer-link\" href=\"/explorer/blocks\" data-explorer-nav=\"all-blocks\">View all blocks</a>\n      </div>\n    </section>\n  ");
};